import request from '@/utils/request';

const PATH = '/stay/room/close';

export const changeStayRoomStatus = (data: any) => request({
  url: PATH,
  method: 'put',
  data,
});
